import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { OAuthService } from 'angular-oauth2-oidc';
import { distinctUntilChanged, filter, map, Observable, startWith } from 'rxjs';
import { AuthState } from '../models/auth-state.model';
import { AuthStore } from './auth.store';

@Injectable({ providedIn: 'root' })
export class AuthQuery extends Query<AuthState> {
  constructor(protected readonly authStore: AuthStore, private readonly oauthService: OAuthService) {
    super(authStore);
  }

  readonly ssoIdp$ = this.select((state) => (state.sso.idps || [])[0] || null);
  readonly ssoSession$ = this.select((state) => state.sso.session);

  readonly tokenRefreshing$ = this.select((state) => state.tokenRefreshing);
  readonly twoFactor$ = this.select((state) => state.twoFactor);

  readonly token$: Observable<string> = this.oauthService.events.pipe(
    filter((event) => event.type === 'token_refreshed'),
    startWith(undefined),
    map(() => this.getAccessToken()),
    distinctUntilChanged(),
  );

  getAccessToken(): string {
    // Returns null when not logged-in
    return this.oauthService.getAccessToken();
  }

  getRedirectUrlAfterLogin(): string | null {
    return this.getValue().redirectUrlAfterLogin;
  }

  hasValidAccessToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  isLoggedIn(): boolean {
    return !!this.getAccessToken();
  }

  getTokenRefreshing(): boolean {
    return this.getValue().tokenRefreshing;
  }
}
